import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
@Component({
  selector: 'app-my-horoscope',
  templateUrl: './my-horoscope.component.html',
  styleUrls: ['./my-horoscope.component.css']
})
export class MyHoroscopeComponent implements OnInit {
  profileId: string = '';
  horoscopeData: any = null;
  loading: boolean = true;
  saving: boolean = false;
  
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  
  horoscopeForm: FormGroup;
  successMessage: string = '';
  errorMessage: string = '';
  isNonReligiousUser: boolean = false;

  get viewUrl(): string {
    return `${environment.apiUrl}/profile_mgmt/horoscope/view/${this.profileId}`;
  }

  constructor(
    private apiService: ApiServiceService,
    private fb: FormBuilder,
    private location: Location,
  ) {
    this.profileId = localStorage.getItem('profileId') || '';
    this.horoscopeForm = this.fb.group({
      visibility: ['Accepted Matches Only']
    });
  }

  ngOnInit(): void {
    this.loadProfile();
  }
  goBack(): void {
  this.location.back();
}

  loadProfile() {
    this.loading = true;
    const sessionToken = localStorage.getItem('sessionToken');
    if (!sessionToken) {
      this.errorMessage = 'Please log in to manage your horoscope.';
      this.loading = false;
      return;
    }
    this.apiService.getEditDetails(sessionToken, this.profileId).subscribe(
      (res: any) => {
        if (res.status === 'success' && res.data) {
          const relId = res.data.religion_info?.religion_id;
          const relIdStr = typeof relId === 'object' ? relId?._id : relId;
          const relName = res.data.religion_info?.religion_nme || '';
          this.isNonReligiousUser = String(relIdStr) === '66040275ccff8db6ddf8eecb' || relName.toLowerCase().includes('non-relig') || relName.toLowerCase().includes('atheist') || relName.toLowerCase().includes('secular');

          this.horoscopeData = {
            url: res.data.horoscope_file_url,
            name: res.data.horoscope_file_name,
            type: res.data.horoscope_file_type,
            uploadedAt: res.data.horoscope_uploaded_at,
            visibility: res.data.horoscope_visibility || 'Accepted Matches Only'
          };
          this.horoscopeForm.patchValue({
            visibility: this.horoscopeData.visibility
          });
        }
        this.loading = false;
      },
      (error: any) => {
        console.error('Error loading profile:', error);
        this.errorMessage = 'Failed to load profile data.';
        this.loading = false;
      }
    );
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        this.errorMessage = 'File size must be less than 10MB.';
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
      this.errorMessage = '';
      
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = e => this.previewUrl = reader.result;
        reader.readAsDataURL(file);
      } else {
        this.previewUrl = null;
      }
    }
  }

  removeSelectedFile() {
    this.selectedFile = null;
    this.previewUrl = null;
    const fileInput: any = document.getElementById('horoscopeUpload');
    if (fileInput) fileInput.value = '';
  }

  saveHoroscope() {
    this.saving = true;
    this.successMessage = '';
    this.errorMessage = '';

    const formData = new FormData();
    if (this.selectedFile) {
      formData.append('horoscope', this.selectedFile);
    }
    formData.append('visibility', this.horoscopeForm.value.visibility);

    this.apiService.uploadHoroscope(this.profileId, formData).subscribe(
      (res: any) => {
        if (res.status === 'success') {
          this.successMessage = 'Horoscope settings updated successfully.';
          this.selectedFile = null;
          this.previewUrl = null;
          // Refresh data
          this.loadProfile();
        } else {
          this.errorMessage = res.message || 'Failed to update horoscope.';
        }
        this.saving = false;
      },
      (error: any) => {
        console.error('Error saving horoscope:', error);
        this.errorMessage = 'An error occurred while saving.';
        this.saving = false;
      }
    );
  }

  downloadBiodata() {
    this.apiService.downloadBiodataPdf(this.profileId, this.profileId).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Biodata_${this.profileId}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error: any) => {
        console.error('Download error:', error);
        this.errorMessage = 'Failed to generate Biodata PDF.';
      }
    );
  }
}
